import React, {Component} from 'react';
import PropTypes from 'prop-types';
import TaskTable from '../task-table-v3/task_table';
import {injectIntl} from 'react-intl';
import {withRouter} from 'react-router-dom';
import moment from 'moment';
import Util from '../../../forecast-app/shared/util/util';
import {WorkflowCategories} from '../../../constants';
import CreateTaskMutation from '../../../mutations/create_task_mutation';
import ScopingAddTask from './scoping_add_task';
import {createToast} from '../../../forecast-app/shared/components/toasts/another-toast/toaster';

class PhasesPhase extends Component {
	constructor(props) {
		super(props);
		let expanded = true;
		if (props.phase.deadlineDay) {
			const date = Util.CreateNonUtcMomentDate(props.phase.deadlineYear, props.phase.deadlineMonth, props.phase.deadlineDay);
			if (moment().isAfter(date) && props.phase.tasks.filter(task => task.statusColumnV2.category !== WorkflowCategories.DONE).length === 0) {
				expanded = false;
			}
		}
		this.state = {
			inputPhaseTitle: this.props.phase.name || '',
			expanded: expanded,
		};
	}

	componentDidMount() {
		if (this.props.focusAddControls) {
			if (this.nameInput) this.nameInput.select();
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		if (
			nextProps.isDraggingSomething &&
			((nextProps.tasksBeingDragged.length !== 0 && nextProps.tasksBeingDragged[0].node.phase && nextProps.tasksBeingDragged[0].node.phase.id !== this.props.phase.id) ||
				(nextProps.tasksBeingDragged.length !== 0 && !nextProps.tasksBeingDragged[0].node.phase && this.props.phase.id) ||
				(nextProps.tasksBeingDragged.length !== 0 && nextProps.tasksBeingDragged[0].node.phase && !this.props.phase.id)) &&
			!this.props.phase.forceRender
		) {
			return false;
		}
		return true;
	}

	componentDidUpdate(prevProps, prevState) {
		if (!prevState.expanded && this.state.expanded) {
			//this.props.calculateTablesSize();
		}
	}

	handleAddTask(projectId, name, role, lowEstimate, highEstimate, forecast, approved, phaseId, assignedPersons) {
		if (this.props.projectLocked) {
			return;
		}
		const onSuccess = res => {
			if (this.props.fixedPriceUtil) {
				this.props.fixedPriceUtil.addTask(res.createTask.task.node);
			}
			createToast({
				duration: 5000,
				message: this.props.intl.formatMessage({
					id: 'task_activity_log.CARD_CREATE',
				}),
				actionText: this.props.intl.formatMessage({id: 'common.see_task'}),
				actionCallback: () => Util.showTaskModal(res.createTask.task.node.companyTaskId, this.props.history),
			});
			this.setState({createdTask: res.createTask.task});
		};
		if (projectId && name) {
			const assignedPersonsIds = assignedPersons.map(person => person.id);
			const mutationObject = {
				projectId: projectId,
				name: name,
				estimateLow: lowEstimate,
				estimateHigh: highEstimate,
				forecast: forecast ? forecast : undefined,
				approved: approved,
				phaseId: phaseId,
				assignedPersons: assignedPersonsIds,
				placementOfTask: 'BOTTOM',
			};
			if (role) {
				mutationObject.roleId = role.id;
			}
			Util.localStorageDeleteFincancialMap();
			Util.CommitMutation(CreateTaskMutation, mutationObject, onSuccess);
		}
	}

	render() {
		return (
			<div className={'phase' + (!this.props.emptyPhase ? ' has-milestone' : '')} style={{minWidth: this.props.tableMinWidth}}>
				<div
					className={'body' + (this.props.sideBacklog ? ' side-backlog' : '')}
					id={this.props.phase.id !== undefined ? 'phase-' + this.props.phase.id : ''}
					style={{minWidth: this.props.tableMinWidth - 132}}
					data-userpilot={this.props.phaseIndex === 0 ? 'milestone-first' : ''}
				>
					<TaskTable
						lazyDataFetched={this.props.timeRegistrationsLoaded}
						showPhaseBaselineHeader={this.props.showPhaseBaselineHeader}
						showPhaseBaselineInfo={this.props.showPhaseBaselineInfo}
						onSelectAllTasks={this.props.onSelectAllTasks}
						onDeselectAllTasks={this.props.onDeselectAllTasks}
						dragActive={this.props.dragActive}
						disabled={this.props.projectLocked}
						collapsed={this.props.collapsed}
						isEmpty={this.props.emptyPhase}
						rowHeight={40}
						listHeaderHeight={40}
						phase={this.props.phase}
						cy={this.props.cy}
						fixedPriceDataProjectMap={this.props.fixedPriceDataProjectMap}
						fixedPriceUtil={this.props.fixedPriceUtil}
						isConnectedParent={this.props.isConnectedParent}
						minutesPerEstimationPoint={this.props.minutesPerEstimationPoint}
						dragAndDropGroup={this.props.dragAndDropGroup}
						taskCellMaxWidth={this.props.taskCellMaxWidth}
						currencySymbol={this.props.currencySymbol}
						emptyPhase={this.props.emptyPhase}
						forceHidden={this.props.forceHidden}
						sortedSprints={this.props.sortedSprints}
						handleRowSelected={this.props.handleRowSelected}
						showTaskModal={this.props.showTaskModal}
						projectLocked={this.props.projectLocked}
						isJiraProject={this.props.isJiraProject}
						projectPersons={this.props.projectPersons}
						roles={this.props.roles}
						selectedRows={this.props.selectedRows}
						isEstimatedInHours={this.props.isEstimatedInHours}
						groupByPerson={this.props.groupByPerson}
						groupByRole={this.props.groupByRole}
						showEmptyPersons={this.props.showEmptyPersons}
						selectionMode={this.props.selectionMode}
						containerWidth={this.props.containerWidth}
						phaseHeader={this.props.phaseHeader}
						id={this.props.phase.id}
						tasks={this.props.phase.tasks}
						projectId={this.props.projectId}
						hasRateCard={this.props.hasRateCard}
						placeUnitBeforeValue={this.props.placeUnitBeforeValue}
						hasFinancialAccess={this.props.hasFinancialAccess}
						language={this.props.language}
						//assignablePersons={this.props.viewer.project.projectPersons.edges}
						//assignableRoles={this.props.viewer.company.roles.edges}
						phaseIndex={this.props.phaseIndex}
						addTaskToBulkUpdate={this.props.addTaskToBulkUpdate}
						removeTaskFromBulkUpdate={this.props.removeTaskFromBulkUpdate}
						bulkUpdateTasks={this.props.bulkUpdateTasks}
						projectTasks={this.props.projectTasks}
						viewer={this.props.viewer}
						availableColumns={this.props.availableColumns}
						columnWidths={this.props.columnWidths}
						onContextMenu={this.props.onContextMenu}
						createdTask={this.state.createdTask}
						allowedPersonsForGroupBy={this.persons}
						parentType={'phase'}
						// showTaskLocationModal={this.props.showTaskLocationModal}
						unselectTasks={this.props.unselectTasks}
						compactShowYear={true}
					/>

					{this.props.collapsed ? null : (
						<div className={'phase-bottom-section' + (this.props.groupByPerson || this.props.groupByRole ? ' grouped' : '')}>
							<ScopingAddTask
								isEmpty={this.props.emptyPhase}
								disabled={!this.props.timeRegistrationsLoaded || this.props.projectLocked}
								isEstimatedInHours={this.props.isEstimatedInHours}
								removeLowHigh={this.props.viewer.project.estimationUnit === 'POINTS' || this.props.viewer.availableFeatureFlags.some(flag => flag.key === 'remove_low_high')}
								availableColumns={this.props.availableColumns}
								containerWidth={this.props.containerWidth}
								isWhite={this.props.emptyPhase}
								projectId={this.props.projectId}
								phase={this.props.phase}
								phaseIndex={this.props.phaseIndex}
								addTask={this.handleAddTask.bind(this)}
								viewer={this.props.viewer}
							/>
						</div>
					)}
				</div>
			</div>
		);
	}
}

PhasesPhase.propTypes = {
	phase: PropTypes.object.isRequired,
	roles: PropTypes.array.isRequired,
	emptyPhase: PropTypes.bool.isRequired,
	locale: PropTypes.string,
	hasRateCard: PropTypes.bool.isRequired,
	focusAddControls: PropTypes.bool,
	projectLocked: PropTypes.bool.isRequired,
	placeUnitBeforeValue: PropTypes.bool.isRequired,
	hasFinancialAccess: PropTypes.bool.isRequired,
	isJiraProject: PropTypes.bool,
};

PhasesPhase.defaultProps = {
	timeRegistrationsLoaded: true,
};

export default withRouter(injectIntl(PhasesPhase, {forwardRef: true}));
